var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { NavVariants } from './NavVariants';
import styles from '../../@patternfly/patternfly-next/components/Nav/nav.css.js';
import { css } from '@patternfly/react-styles';
import { PageContext } from '../../layouts/Page/Page';

var propTypes = {
  /** Indicates the list type. */
  variant: PropTypes.oneOf(Object.values(NavVariants)),
  /** Children nodes */
  children: PropTypes.node,
  /** Additional classes added to the list */
  className: PropTypes.string,
  /** Impacts horizontal nav only: If true makes the nav taller. If nav is within a Page layout,
   * the layout sets this prop automatically if the Page useCondensed feature is enabled. */
  isTall: PropTypes.bool
};

var defaultProps = {
  variant: 'default',
  children: null,
  className: '',
  isTall: false
};

var NavList = function NavList(_ref) {
  var _variantStyle;

  var variant = _ref.variant,
      children = _ref.children,
      className = _ref.className,
      isTall = _ref.isTall,
      props = _objectWithoutProperties(_ref, ['variant', 'children', 'className', 'isTall']);

  var variantStyle = (_variantStyle = {}, _defineProperty(_variantStyle, NavVariants.default, styles.navList), _defineProperty(_variantStyle, NavVariants.simple, styles.navSimpleList), _defineProperty(_variantStyle, NavVariants.horizontal, styles.navHorizontalList), _defineProperty(_variantStyle, NavVariants.tertiary, styles.navTertiaryList), _variantStyle);

  return React.createElement(
    PageContext.Consumer,
    null,
    function (context) {
      return React.createElement(
        'ul',
        _extends({
          className: css(variantStyle[variant], (context && context.isTall || isTall) && styles.modifiers.tall, className)
        }, props),
        children
      );
    }
  );
};

NavList.propTypes = propTypes;
NavList.defaultProps = defaultProps;
NavList.componentType = 'NavList';

export default NavList;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/components/Nav/NavList.js
// module id = 268
// module chunks = 0